<template>
  <v-expansion-panels focusable>
    <v-expansion-panel v-for="(r, i) in resource.candidates" :key="'resource-'+i"  style="cursor:pointer;">
      <v-expansion-panel-header>
        <v-row class="pa-0 align-center">
          <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1`" PROGRAM v-if="r.country_name">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-chip color="secondary" 
                    label x-small style="text-transform:uppercase;" 
                    v-if="r.country_name && r.country_name.slug"
                  >{{r.country_name.slug}}</v-chip>
                  <v-progress-circular indeterminate v-if="!r.country_name || !r.country_name.slug" color="primary"></v-progress-circular>
                </span>
              </template>
              <div class="text-center">
                <div :class="`${arabic?'arFont':'enFont'}`" style="text-transform:uppercase;"
                  v-if="r.country_name && r.country_name.slug"
                >{{r.country_name.slug}}</div>
                <div :class="`${arabic?'arFont':'enFont'}`" style="text-transform:uppercase;"
                  v-if="r.country_name && r.country_name.slug"
                >{{r.country_name.slug}}</div>
              </div>
            </v-tooltip>
          </v-col>
          <v-col cols="6" md="3" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 font-weight-bold`" NAME>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span class="px-1" v-bind="attrs" v-on="on">{{r.name}}</span>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-if="r.multiple" dark v-bind="attrs" v-on="on" size="14" color="red">mediation</v-icon>
                  </template>
                  <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                    <v-icon dark size="18">mediation</v-icon> {{i18n.duplicate}}
                  </span>
                </v-tooltip>
              </template>
              <div class="text-center">
                <div :class="`${arabic?'arFont':'enFont'}`">{{r.email}}</div>
                <div :class="`${arabic?'arFont':'enFont'}`">{{r.phone}}</div>
                <div :class="`${arabic?'arFont':'enFont'} pa-0`">
                  {{r.aramcco_code}}
                </div>
              </div>
            </v-tooltip>
          </v-col>
          <v-col cols="6" md="3" :class="`${arabic?'arFont':'enFont'} pa-0 py-1`" DATETIME>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" v-if="r.created_at">
                  <v-icon size="10">date_range</v-icon>
                  {{r.created_at.split('T')[0]}} |
                  <v-icon size="10">schedule</v-icon>
                  {{r.created_at.split('T')[1].split('.')[0]}}</span>
              </template>
              <div class="text-center">
                <div v-if="r.created_at" :class="`${arabic?'arFont':'enFont'} pa-0`">{{getFormat(r.created_at)}}</div>
              </div>
            </v-tooltip>
          </v-col>
          <v-col cols="6" md="4" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 adminSwitch text-center`" EDITBUTTON>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" >
                  <span style="font-size:11px;" class="px-2">ACCEPTED
                    <v-icon color="success" size="14" v-if="r.accepted">
                      task_alt
                    </v-icon>
                    <v-icon color="error" size="14" v-else>
                      close
                    </v-icon>
                  </span>
                  <v-btn color="success" 
                    :disabled="r.lock"
                    x-small @click.stop="accept(r)">
                    <v-icon left size="12">done</v-icon>
                    accept
                  </v-btn>
                  <v-btn color="error" class="mx-1"
                    :disabled="r.lock"
                    x-small @click.stop="reject(r)">
                    <v-icon left size="12">close</v-icon>
                    reject
                  </v-btn>
                </span>
              </template>
              <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                EARLY RESULT
              </span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-divider class="pb-3"></v-divider>
        <v-row class="pa-0 align-center">
          <v-col cols="6" md="3" v-for="(key, det) in Object.keys(r).filter(key=>(!key.includes('_name') && typeof r[key] == 'string') || (key.includes('_name') && r[key]))" :key="'details'+det"
            :class="`${arabic?'arFont':'enFont'} pa-0`">
            <div style="font-size:9px;font-weight:700;text-transform:uppercase;"
              v-if="(!key.includes('_name') && typeof r[key] == 'string') || (key.includes('_name') && r[key])"
            >{{i18n[key]}}</div>
            <div style="font-size:12px;"
              v-if="!key.includes('_name') && typeof r[key] == 'string'"
              v-clipboard:copy="r[key]"
              v-clipboard:success="clipboardSuccessHandler"
              v-clipboard:error="clipboardErrorHandler"
            >
              {{r[key]}}
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" color="error" size="14" v-if="key == 'email' && r.match_sub && r.match_sub.bounced">cancel_schedule_send</v-icon>
                </template>
                <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                  Wrong Email
                </span>
              </v-tooltip>
            </div>
            <div style="font-size:12px;"
              v-if="key.includes('_name') && r[key]"
              v-clipboard:copy="i18n[r[key].slug]"
              v-clipboard:success="clipboardSuccessHandler"
              v-clipboard:error="clipboardErrorHandler"
            >
              {{ r[key].slug ? i18n[r[key].slug] : r[key].name }}
            </div>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { format, render, cancel, register } from 'timeago.js';
export default {
  props:['resourceSettings', 'resource' , 'resourceKeys', 'match'],
  methods:{
    openLink(url) {
      window.open(url, '_blank');
    },
    getColor(status) {
      if(status == 'new') {
        return 'success'
      } else
      if(status == 'to_create') {
        return '#9c27b0'
      } else
      if(status == 'confirmed') {
        return 'primary'
      } else
      if(status == 'interview') {
        return '#8bc34a'
      } else
      if(status == 'accepted') {
        return '#00bcd4'
      } else
      if(status == 'need_follow_up' || status == 'out_of_reach') {
        return "#FFC107"
      } else {
        return 'error'
      }
    },
    accept(r) {
      this.$emit('accept', r)
    },
    reject(r) {
      this.$emit('reject', r)
    },
    edit(r) {
      this.$emit('editLead', r)
    },
    getFormat(d){
      return format(d)
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('copyS', { value, event })
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('copyF', { value, event })
    },
  },
  computed:{
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    user(){
      return this.$store.state.user
    },

  }
}
</script>

<style>

</style>